module.exports = __webpack_public_path__ + "akne_5_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/akne_5_after.jpg
// module id = 923
// module chunks = 0